module.exports = __webpack_public_path__ + "static/media/Character1_TopLayer.6516197a.svg";